import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import styles from './MonthSelectBox.css';

class MonthSelectBox extends React.Component {
  render() {
    return (
      <div
        className={
          !this.props.fullSiteMode ? styles.wrapper : styles['wrap-full-site']
        }
      >
        <div className="row">
          <div className="col-md-12">
            <table className={styles.table} cellSpacing="0">
              <thead>
                <tr>
                  <td>
                    <button
                      className={`btn btn-default ${styles.btn}`}
                      onClick={() => this._previousMonth()}
                    >
                      <span className="fa fa-angle-left" />
                    </button>
                  </td>
                  <td colSpan="5">
                    <span className={styles.month}>{this._monthLabel()}</span>
                    &nbsp;
                    <span className={styles.year}>{this._yearLabel()}</span>
                  </td>
                  <td>
                    <button
                      className={`btn btn-default ${styles.btn}`}
                      onClick={() => this._nextMonth()}
                    >
                      <span className="fa fa-angle-right" />
                    </button>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    );
  }

  _previousMonth = () => {
    const { year, month } = this.props;
    const newDate = moment({ year, month }).add(-1, 'months');
    this.props.onChange({
      year: newDate.year(),
      month: newDate.month(),
    });
  };

  _nextMonth = () => {
    const { year, month } = this.props;
    const newDate = moment({ year, month }).add(1, 'months');
    this.props.onChange({
      year: newDate.year(),
      month: newDate.month(),
    });
  };

  _monthLabel = () => {
    const { year, month } = this.props;
    return moment({ year, month }).format('MMMM');
  };

  _yearLabel = () => {
    const { year, month } = this.props;
    return moment({ year, month }).format('YYYY');
  };
}

MonthSelectBox.propTypes = {
  year: PropTypes.number,
  month: PropTypes.number,
};
export default MonthSelectBox;
